import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Brand} from "@mytour/platform";
import {useState} from "react";
import {Collapse, Nav, Navbar, NavbarToggler} from "reactstrap";
import "../menus/header.scss";
import {AccountMenu} from "./menus/AccountMenu";
import {EntitiesMenu} from "./menus/EntitiesMenu";

export function ManagerHeader() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <div id="app-header">
      <Navbar dark expand="md" fixed="top" className="jh-navbar">
        <Brand />
        <Nav navbar>
          <EntitiesMenu onClick={() => menuOpen && toggleMenu()} />
        </Nav>
        <NavbarToggler aria-label="Menu" onClick={toggleMenu}>
          <FontAwesomeIcon icon="cog" />
        </NavbarToggler>
        <Collapse isOpen={menuOpen} navbar>
          <Nav id="header-tabs" className="ml-auto" navbar>
            <AccountMenu onClick={toggleMenu} />
          </Nav>
        </Collapse>
      </Navbar>
    </div>
  );
}
